import { colors, Flex, space, TableRow, Text } from '@workday/canvas-kit-react'
import React from 'react'

export interface SectionHeaderProps {
  title: string
  count: number
}

const SectionHeader = ({ title, count }: SectionHeaderProps) => {
  return (
    <TableRow>
      <td
        style={{
          border: 0,
          padding: `${space.xxxs} ${space.s} ${space.xxxs} ${space.s}`,
          margin: 0,
          backgroundColor: colors.soap400,
          borderBottom: `1px solid ${colors.soap600}`,
          height: 'auto'
        }}
      >
        <Text typeLevel="body.small" fontWeight="medium" color={colors.blackPepper400}>
          <Flex flexDirection="row" gap={space.xs}>
            <Text>{title}</Text>
            <Flex.Item flex={1} />
            <Text>({count})</Text>
          </Flex>
        </Text>
      </td>
    </TableRow>
  )
}

export default SectionHeader
